
import { CustomAutocomplete } from 'common'

import { Button, FormControl, Grid, TextField } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

const ContractFormStepApplies = ({useFetchInit}) => {

    const {
        globalStates,
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { stepApplilication } = globalStates

    const { FormLeases } = Forms
    const { formState, onInputChange, onSelectSearchChange, onInputNumberChange } = FormLeases
    
    const { fetchAllHouses, fetchAllCustomers } = FetchData
    const { houses } = fetchAllHouses
    const { customers } = fetchAllCustomers

    const { handleClickReturnStep, onSubmitFormApplies, handleChangeHouses, handleChangeTotalMonths } = Actions

    return (
        <form onSubmit={onSubmitFormApplies}>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_fecha">* Fecha de registro</label>
                        <TextField
                            id='contrato_fecha'
                            name='contrato_fecha'
                            value={ formState.contrato_fecha }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Fecha de registro'
                            type='date'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_dia_pago">* Día de pago</label>
                        <TextField
                            id='contrato_dia_pago'
                            name='contrato_dia_pago'
                            value={ formState.contrato_dia_pago }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Día de pago'
                            type='date'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} >
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="idcasa">* Casa</label>
                        <CustomAutocomplete 
                            customId="idcasa"
                            customName="idcasa"
                            customValue={formState.idcasa}
                            customOnChange={(target, value) => handleChangeHouses({ target: { name: 'idcasa', value: value.value }})}
                            customPlaceholder='Seleccionar casa'
                            customOptions={
                                houses.map(({ idcasa, descripcion_corta, costo_alquiler }) => ({
                                    value: JSON.stringify({ idcasa, costo_alquiler }),
                                    name: descripcion_corta
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="idcliente">* Cliente</label>
                        <CustomAutocomplete 
                            customId="idcliente"
                            customName="idcliente"
                            customValue={formState.idcliente}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcliente', value: value.value }  })}
                            customPlaceholder='Seleccionar cliente'
                            customOptions={
                                customers.map(({ idcliente, dpi, nombre }) => ({
                                    value: idcliente,
                                    name: `${dpi} - ${nombre}`
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_plazo_meses">* Plazo Meses</label>
                        <TextField
                            id='contrato_plazo_meses'
                            name='contrato_plazo_meses'
                            size='small'
                            value={ formState.contrato_plazo_meses }
                            onChange={ handleChangeTotalMonths }
                            placeholder='Plazo Meses'
                            type='number'
                            min="0"
                            step="1"
                            hiddenLabel
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_costo_alquiler">* Costo del alquiler (Q)</label>
                        <TextField
                            id='contrato_costo_alquiler'
                            name='contrato_costo_alquiler'
                            value={ formState.contrato_costo_alquiler_mask }
                            onChange={ onInputNumberChange }
                            placeholder='Costo del alquiler'
                            size='small'
                            type='text'
                            variant="filled"
                            hiddenLabel
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_total_alquiler">* Total del alquiler (Q)</label>
                        <TextField
                            id='contrato_total_alquiler'
                            name='contrato_total_alquiler'
                            value={ formState.contrato_total_alquiler_mask }
                            onChange={ onInputNumberChange }
                            placeholder='Costo del alquiler'
                            size='small'
                            type='text'
                            variant="filled"
                            hiddenLabel
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_papeleria">* Papelería (Q)</label>
                        <TextField
                            id='contrato_papeleria'
                            name='contrato_papeleria'
                            value={ formState.contrato_papeleria_mask }
                            onChange={ onInputNumberChange }
                            placeholder='Papelería'
                            size='small'
                            type='text'
                            variant="filled"
                            hiddenLabel
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_deposito">* Depósito (Q)</label>
                        <TextField
                            id='contrato_deposito'
                            name='contrato_deposito'
                            value={ formState.contrato_deposito_mask }
                            onChange={ onInputNumberChange }
                            placeholder='Depósito'
                            size='small'
                            type='text'
                            variant="filled"
                            hiddenLabel
                            InputProps={{
                                readOnly: true
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_observaciones"> Observaciones</label>
                        <TextField 
                            id='contrato_observaciones'
                            name='contrato_observaciones'
                            value={ formState.contrato_observaciones }
                            onChange={ onInputChange }
                            placeholder='Observaciones'
                            size='small'
                            multiline
                            rows={3}
                            type='text'
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                <Grid item xs={12}>
                    <div className="text-center">
                        {stepApplilication !== 0 && (
                            <Button 
                                startIcon={<ArrowLeftCircle/>}
                                variant="contained"
                                type="button"
                                onClick={handleClickReturnStep} 
                                sx={{ marginRight: 1, marginLeft: 1, background: "#ef8157" }}
                            >
                                Volver
                            </Button>
                        )}
                        <Button
                            endIcon={<ArrowRightCircle/>}
                            variant="contained"
                            type="submit"
                            style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                        >
                            {stepApplilication === 4 ? 'Finalizar' : 'Continuar'}
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </form>

    )
    
}

export {
    ContractFormStepApplies
}